import { BillType } from "../../../interfaces/BillInterfaces";

import { CalendarFunctions as calFns } from "../../../components/Calendar";

const GroupBillsByDate = (bills: BillType[]): { [key: string]: BillType[] } => {
  const sortedBills = bills.sort(
    (a, b) => new Date(b.issueDate).getTime() - new Date(a.issueDate).getTime()
  );
  return sortedBills.reduce((acc, bill) => {
    const { issueDate } = bill;
    const groupKey = calFns.convertADtoBS(new Date(issueDate)).formatted5;
    const newAcc = { ...acc };
    if (!newAcc[groupKey]) {
      newAcc[groupKey] = [];
    }
    newAcc[groupKey].push(bill);
    return newAcc;
  }, {} as { [key: string]: BillType[] });
};

export default GroupBillsByDate;
